import { render, staticRenderFns } from "./addCollectCardAct.vue?vue&type=template&id=85e134a2&scoped=true&"
import script from "./addCollectCardAct.vue?vue&type=script&lang=js&"
export * from "./addCollectCardAct.vue?vue&type=script&lang=js&"
import style0 from "./addCollectCardAct.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./addCollectCardAct.vue?vue&type=style&index=1&id=85e134a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e134a2",
  null
  
)

component.options.__file = "addCollectCardAct.vue"
export default component.exports